class SubNavigation {
    constructor(_sec, _list, _useSubNavi){
        this.useSubNavi = _useSubNavi;
        if(!this.useSubNavi) return;

        this.section = _sec;
        this.articleList = $(_list);

        this.container = null;
        if( this.articleList.length > 1 ){
            this.section.append( this.makeNavi() );
        }
    }

    makeNavi(){
        let list = '';
        this.articleList.map( (idx, it) => {
            list += `<a href="#${it.anchor}">${idx+1}</a>`;
        });
        return `<nav class="sub-navi">${ list }</nav>`;
    }

    setActive(_d2){
        if(!this.useSubNavi) return;
        this.section.find('.sub-navi a').removeClass('active');
        this.section.find('.sub-navi a').eq(_d2-1).addClass('active');
    }

}

export default SubNavigation;


// WEBPACK FOOTER //
// ./SubNavigation.js